import * as constants from './constants';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';
import reducer from './reducer';
import ComplianceActivitiesGrid from './components/ComplianceActivitiesGrid';
import ActivityDetails from './components/ActivityDetails';
import DelegatedWaitingForApprovalActivitesGrid from './components/DelegatedWaitingForApprovalActivitesGrid';
import MyActivitiesGrid from './components/MyActivitiesGrid';
import WaitingForApprovalActivitiesGrid from './components/WaitingForApprovalActivitiesGrid';

export default {
    constants, reducer, actions, actionTypes, selectors,
    ComplianceActivitiesGrid, ActivityDetails,
    DelegatedWaitingForApprovalActivitesGrid, WaitingForApprovalActivitiesGrid,
    MyActivitiesGrid
}